import React, { useState } from "react";
import "./recent-designs.scss";
import { Tabs, Tab, Menu, MenuItem, InputBase } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const recentDesignsData = [
  { id: 'IW-2026-000032', status: 'Draft', date: 'May 20, 2026', time: '11:32 AM', resolution: '2048 x 2048', img: '/static/images/design1.png' },
  { id: 'IW-2026-000033', status: 'In Review', date: 'May 21, 2026', time: '2:45 PM', resolution: '1920 x 1080', img: '/static/images/design2.png' },
  { id: 'IW-2026-000034', status: 'Approved', date: 'May 22, 2026', time: '9:15 AM', resolution: '2560 x 1440', img: '/static/images/design3.png' },
  { id: 'IW-2026-000035', status: 'Revision Needed', date: 'May 23, 2026', time: '4:00 PM', resolution: '1280 x 720', img: '/static/images/design4.png' },
  { id: 'IW-2026-000036', status: 'Finalized', date: 'May 24, 2026', time: '10:30 AM', resolution: '3840 x 2160', img: '/static/images/design5.png' },
  { id: 'IW-2026-000037', status: 'Approved', date: 'May 22, 2026', time: '9:15 AM', resolution: '2560 x 1440', img: '/static/images/design6.png' },
  { id: 'IW-2026-000038', status: 'Archived', date: 'May 26, 2026', time: '3:50 PM', resolution: '1024 x 768', img: '/static/images/design7.png' },
  { id: 'IW-2026-000039', status: 'Published', date: 'May 27, 2026', time: '12:05 PM', resolution: '2048 x 1536', img: '/static/images/design8.png' },
  { id: 'IW-2026-000040', status: 'In Review', date: 'May 21, 2026', time: '2:45 PM', resolution: '1920 x 1080', img: '/static/images/design9.png' },
  { id: 'IW-2026-000041', status: 'Archived', date: 'May 26, 2026', time: '3:50 PM', resolution: '1024 x 768', img: '/static/images/design10.png' },
];

// Map status to modifier class
const getStatusClass = (status: string) => {
  const normalized = status.toLowerCase().replace(' ', '-');
  return `status--${normalized}`;
};

const RecentDesigns = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openSort = Boolean(anchorEl);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  const handleSortClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSortClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="recent_designs_page">
      <div className="recent_designs_page__header">
        <div className="header_left">
          <h1>Recent Designs</h1>
          <p>Browse and manage all your previously generated designs.</p>
        </div>

        <div className="header_right">
          <div className="search_box">
            <SearchIcon className="search_icon" />
            <InputBase placeholder="Search by Design ID..." className="search_input" />
          </div>
          <button className="filter_btn">
            <FilterAltIcon /> Filter
          </button>
        </div>
      </div>

      <div className="recent_designs_page__filters">
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          className="status_tabs"
          TabIndicatorProps={{ style: { display: 'none' } }}
        >
          <Tab label={<div className="tab_label">All Designs <span className="count_badge">32</span></div>} disableRipple />
          <Tab label={<div className="tab_label">Draft <span className="count_badge">8</span></div>} disableRipple />
          <Tab label={<div className="tab_label">Customized <span className="count_badge">10</span></div>} disableRipple />
          <Tab label={<div className="tab_label">Saved <span className="count_badge">9</span></div>} disableRipple />
          <Tab label={<div className="tab_label">Approved <span className="count_badge">5</span></div>} disableRipple />
          <Tab label={<div className="tab_label">Archived <span className="count_badge">3</span></div>} disableRipple />
        </Tabs>

        <div className="sort_box">
          <span className="sort_label">Sort by:</span>
          <button className="sort_btn" onClick={handleSortClick}>
            Newest First <KeyboardArrowDownIcon />
          </button>
          <Menu
            anchorEl={anchorEl}
            open={openSort}
            onClose={handleSortClose}
            PaperProps={{ className: 'sort_menu_paper' }}
          >
            <MenuItem onClick={handleSortClose}>Newest First</MenuItem>
            <MenuItem onClick={handleSortClose}>Oldest First</MenuItem>
          </Menu>
        </div>
      </div>

      <div className="recent_designs_page__grid">
        {recentDesignsData.map((design, index) => (
          <div className="design_card" key={index}>
            <div className="card_image">
              <img src={design.img} alt={`Design ${design.id}`} />
              <button className="action_btn"><MoreHorizIcon /></button>
            </div>
            <div className="card_content">
              <div className="card_header">
                <span className="design_id">{design.id}</span>
                <span className={`status_badge ${getStatusClass(design.status)}`}>{design.status}</span>
              </div>
              <div className="card_meta">
                <div className="meta_item">
                  <CalendarTodayIcon className="meta_icon" /> {design.date}
                </div>
                <div className="meta_item">
                  <AccessTimeIcon className="meta_icon" /> {design.time}
                </div>
              </div>
              <div className="card_footer">
                <span className="resolution">{design.resolution}</span>
                <OpenInNewIcon className="open_icon" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentDesigns;
